<div class="p-grid">
    <div class="p-col-12">
        <button pButton label="Exporter en exel" icon="pi pi-file-excel" style="float: right;" (click)="exportExcelByCellRef()"></button>
    </div>
    <div class="p-col-12">
        <p-fileUpload name="myFile[]" [customUpload]="true" (uploadHandler)="convertToJSONbyCellRef($event)" accept=".xls,.xlsx"></p-fileUpload>
    </div>
</div>